// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  // apiUrl: 'http://consentz.lena.ekreative.com/api/v1',
  // apiUrl: 'http://consentz.stageserver.org/api/v1',
  // apiUrl: 'https://staging.consentz.com/api/v1',
  apiUrl: 'https://control.consentz.com/api/v1',
  google: {
    // apiKey: 'AIzaSyCZHLEPx6oV6vY8h7bDfvqSRCQKIJVBS44',
    // apiKey: 'AIzaSyCZHLEPx6oV6vY8h7bDfvqSRCQKIJVBS44',
    // clientId: '329872179012-7r5t0nolfj9vrk5ri3ko84u2j9a988a5.apps.googleusercontent.com',
    // discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest'],
    // scope: 'https://www.googleapis.com/auth/calendar.readonly',
    // requestUrl: 'https://www.googleapis.com/calendar/v3/calendars/nbv1oc3qkgrkreuu2469mcd8ss%40group.calendar.google.com/events?key=AIzaSyBb8E1JfMHvaXvcdpm56RKGt_msDuBMnxs'

    apiKey: 'AIzaSyBb8E1JfMHvaXvcdpm56RKGt_msDuBMnxs',
    clientId:
      '540965763126-uns6m2s0379ruaorlk44b0bdei8d2jcl.apps.googleusercontent.com',
    discoveryDocs: [
      'https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest',
    ],
    scope: 'https://www.googleapis.com/auth/calendar.readonly',
    requestUrl:
      'https://www.googleapis.com/calendar/v3/calendars/nbv1oc3qkgrkreuu2469mcd8ss%40group.calendar.google.com/events?key=AIzaSyBb8E1JfMHvaXvcdpm56RKGt_msDuBMnxs',
  },
  stripe: {
    // publishableKey: "pk_live_1GG6Z6dol0EDTaBKs9uXVskw",
    publishableKey: 'pk_test_LJ0agfIJVDnPOmrs6ViCG6Pv'
  },
};



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/environments/environment.ts